import React from 'react';
import FormattedInput from '../FormattedInput';
import { UserProfile } from '../../types/advanced-retirement';

interface AdvancedSettingsSectionProps {
  userProfile: UserProfile;
  handleInputChange: (field: keyof UserProfile, value: any) => void;
}

const AdvancedSettingsSection: React.FC<AdvancedSettingsSectionProps> = ({
  userProfile,
  handleInputChange
}) => {
  return (
    <div className="section-content">
      <h3>Advanced Settings</h3>
      <div className="form-grid">
        <div className="form-group">
          <label htmlFor="inflationRate">Inflation Rate (%)</label>
          <FormattedInput
            type="number"
            id="inflationRate"
            value={userProfile.inflationRate}
            onChange={(value) => handleInputChange('inflationRate', value)}
            step="0.1"
            min="0"
            max="10"
            formatOptions={{ type: 'percent', decimalPlaces: 2 }}
          />
        </div>
        <div className="form-group">
          <label htmlFor="tfsaAnnualIncrease">TFSA Annual Increase ($)</label>
          <FormattedInput
            type="number"
            id="tfsaAnnualIncrease"
            value={userProfile.tfsaAnnualIncrease}
            onChange={(value) => handleInputChange('tfsaAnnualIncrease', value)}
            step="1000"
            min="0"
            formatOptions={{ type: 'currency', decimalPlaces: 0 }}
          />
        </div>
        <div className="form-group">
          <label>Tax Optimization</label>
          <input
            type="checkbox"
            checked={userProfile.taxOptimization}
            onChange={(e) => handleInputChange('taxOptimization', e.target.checked)}
          />
          <small style={{ display: 'block', marginTop: '0.25rem' }}>
            The optimizer tests RRSP meltdown and income smoothing automatically. Nothing else to set.
          </small>
        </div>
      </div>
    </div>
  );
};

export default AdvancedSettingsSection;
